import React from 'react';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
const TrustSection = () => {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    quote: t.trust.testimonials[0].quote,
    author: t.trust.testimonials[0].author,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80'
  }, {
    quote: t.trust.testimonials[1].quote,
    author: t.trust.testimonials[1].author,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80'
  }, {
    quote: t.trust.testimonials[2].quote,
    author: t.trust.testimonials[2].author,
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80'
  }];
  return <section className="py-12 px-4 bg-sand-50" data-id="element-383" data-mp="38b8sxoxe9v7e">
      <div className="container mx-auto" data-id="element-384" data-mp="3d8intk3jyz2m">
        <div className="text-center mb-10" data-id="element-385" data-mp="3d9jy3mcqvhja">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-386" data-mp="2ybhu5b1swu1i">
            <div className="flex" data-id="element-387" data-mp="2ydcf2pd2om5l">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-[#FFD700] fill-[#FFD700]" data-id="element-388" data-mp="33c5ljxtxzcw9" data-mpi={i} />)}
            </div>
            <span className="font-medium text-primary text-xl" data-id="element-389" data-mp="3vxf9izkvwj98">
              {t.trust.rating}
            </span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-primary mb-2" data-id="element-390" data-mp="3h7rgsmqrqsx4">
            <span className="text-accent bg-primary px-2 py-0.5 rounded-md mr-2" data-id="element-391" data-mp="3m745ze544c2v">
              {t.trust.headline}
            </span>{' '}
            {t.trust.subheadline}
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-392" data-mp="il54hpffyrek">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-custom border border-sand-200 hover:shadow-lg transition-shadow" data-id="element-393" data-mp="sdq39pr0tssb" data-mpi={index}>
              <div className="flex items-center gap-3 mb-4" data-id="element-394" data-mp="jdky7m9av6hb">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-sand-200" data-id="element-395" data-mp="egkuhhzxaftd" />
                <div data-id="element-396" data-mp="4p6w5djpjm1t">
                  <p className="font-medium text-primary" data-id="element-397" data-mp="4oopdmzf5pfn">
                    {testimonial.author}
                  </p>
                  <div className="flex" data-id="element-398" data-mp="3vu6nkt8lcku4">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 text-[#FFD700] fill-[#FFD700]" data-id="element-399" data-mp="3rsuycotmq1mg" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <blockquote data-id="element-400" data-mp="1xfinbsmh4veh">
                <p className="text-gray-700 text-lg italic" data-id="element-401" data-mp="1xe7jjst13nnd">
                  "{testimonial.quote}"
                </p>
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
};
export default TrustSection;